// A link to the Memory tab, never an inline confirm: the settings panel is the one confirm surface.

import React, { useCallback } from 'react';
import { Button } from 'antd';
import { BulbOutlined } from '@ant-design/icons';

import { useSettings } from '../settings/SettingsContext';
import type { MemoryProposalsChipProps } from '../../types/xoe/XoeUiTypes';

const XOE_MEMORY_SETTINGS_TAB = 'xoe-memory';

const memoryProposalsLabel = (count: number): string =>
	`Xoe has ${count} ${count === 1 ? 'suggestion' : 'suggestions'} to remember — review`;

// "review" opens the Memory tab; the count stands down until the next turn reports one.
export const useReviewMemoryProposals = (acknowledge: () => void): (() => void) => {
	const { openSettings } = useSettings();
	return useCallback(() => {
		openSettings(XOE_MEMORY_SETTINGS_TAB);
		acknowledge();
	}, [openSettings, acknowledge]);
};

const MemoryProposalsChip: React.FC<MemoryProposalsChipProps> = ({ count, onReview, tone = 'neutral' }) =>
	count > 0 ? (
		<Button
			type="text"
			size="small"
			icon={<BulbOutlined />}
			onClick={onReview}
			data-testid="xoe-memory-proposals"
			className={`mg-xoe-memory-chip mg-xoe-memory-chip--${tone}`}
		>
			{memoryProposalsLabel(count)}
		</Button>
	) : null;

export default MemoryProposalsChip;
